<template>
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <!-- 我的订单 -->
    <div class="my_order_box">
      <div class="left">
        <leftTemplate :left_tabShow="'my_order'"></leftTemplate>
      </div>
      <div class="right">
        <el-table ref="multipleTableRef" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
          height="500">
          <el-table-column property="name" width="250" label="商品名称">
            <template #default="scope">
              <div style="display: flex">
                <div style="" class="table_img">
                  <img style="width: 100%; height: 100%" :src="scope.row.showImage" />
                </div>
                <div class="table_information">
                  <div style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    ">
                    {{ scope.row.title }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="orderNo" width="220" label="订单号" align="center" />

          <el-table-column property="authType" width="220" label="授权信息" align="center">
            <template #default="scope">
              <!-- <el-tag class="ml-2" type="success" v-if="scope.row.authType == 'SELF'"
            >个人授权</el-tag
          >
          <el-tag class="ml-2" type="success" v-if="scope.row.authType == 'ENTERPRISE'"
            >企业受援</el-tag
          >
          <el-tag class="ml-2" type="success" v-if="scope.row.authType == 'UNION'"
            >企业Plus</el-tag
          > -->
              <span v-if="scope.row.authType == 'SELF'"> 个人授权 </span>

              <span v-if="scope.row.authType == 'ENTERPRISE'"> 企业授权 </span>
              <span v-if="scope.row.authType == 'UNION'"> 联盟授权 </span>
            </template></el-table-column>
          <el-table-column property="sellerPrice" label="价格" align="center" />
          <el-table-column property="price" label="实付" align="center" />
          <el-table-column property="status" label="订单状态" align="center" width="100px">
            <template #default="scope">
              <el-tag v-if="scope.row.status == 0">待支付</el-tag>

              <el-tag class="ml-2" type="info" v-if="scope.row.status == 2">已取消</el-tag>
              <el-tag class="ml-2" type="danger" v-if="scope.row.status == 3">支付失败</el-tag>
              <el-tag class="ml-2" type="success" v-if="scope.row.status == 1">已支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template #default="scope">
              <div v-if="scope.row.status == 0">
                <div style="width: 100px" class="topBtn" @click="goto(scope.row, '/myOrderCheckstand')">
                  支付
                </div>

                <div class="cancellationBtn" @click="cancellationClick(scope.row)">
                  取消订单
                </div>
              </div>
              <div v-if="scope.row.status == 3">
                <div class="cancellationBtn" @click="cancellationClick(scope.row)">
                  取消订单
                </div>
              </div>
              <div v-if="scope.row.status == 1">
                <div v-if="scope.row.sendCount >= 1" @click="invoiceDetail(scope.row, 'view')" style="width: 100px"
                  class="topBtn">
                  查看发票
                </div>
                <div v-else @click="invoiceDetail(scope.row, 'add')" style="width: 100px" class="topBtn">
                  申请发票
                </div>
              </div>
              <div v-if="scope.row.status == 2">
                <div style="width: 100px" class="topBtn" @click="paymentClick(scope.row, '/myOrderCheckstand')">
                  重新购买
                </div>
              </div>
            </template>
          </el-table-column>
          <template #empty>
            <div style="height: 550px" v-if="tableData.length == 0">
              <div style="width: 90%; margin: 0 auto">
                <img style="width: 100%; margin: 0 auto" src="../../assets/zt_404.png" />
              </div>
            </div>
          </template>
        </el-table>

        <!-- 分页 -->
        <div style="display: flex; justify-content: center">
          <el-pagination v-if="tableData.length != 0" v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize" @size-change="sizeChange" @current-change="currentChange"
            style="margin: 0.4rem 0" background layout="prev, pager, next" :total="page.total" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable, ElMessage } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
document.title = "标识山西-我的订单";
const page = pageDef;
interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
}
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      // TODO: improvement typing when refactor table
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  console.log(value, "这里是");
  multipleSelection.value = val;
};

const tableData = ref([]);
const init = () => {
  Axios(
    "get",
    "/fodder/order/my-list",
    {
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
      orderByColumn: "createTime",
      isAsc: "desc",
    },
    false,
    function (res) {
      tableData.value = res.data.rows;
      page.value.total = res.data.total;
    }
  );
};

init();

//支付页
import { useRouter } from "vue-router";
const router = useRouter();
const goto = (row, type) => {
  router.push({
    path: type,
    query: {
      arry: row.id,
      totalPay: row.price,
      type: "order",
    },
  });
};
//重新下订单
const paymentClick = (row, type) => {
  Axios(
    "post",
    "/fodder/order",
    { materialId: row.materialId, authType: row.authType },
    false,
    function (res) {
      console.log(res);
      let data = res.data.data;
      router.push({
        path: type,
        query: {
          arry: data.id,
          totalPay: data.price,
          type: "order",
          authType: row.authType,
        },
      });
    }
  );
};
//取消按钮
const cancellationClick = (row) => {
  Axios("post", "/fodder/order/cancel/" + row.id, {}, false, function (res) {
    init();
    ElMessage({
      message: "取消成功",
      type: "success",
    });
  });
};
//发票
const invoiceDetail = (row, type) => {
  router.push({
    path: "/invoiceDebit",
    query: {
      arry: row.id,
      type: type,
    },
  });
};

/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);

.my_order_box {
  width: 80%;
  display: flex;
  margin: 0 auto;
}

.table_img {
  background-color: #3fa4ed;
  width: 0.6rem;
  height: 0.6rem;
  background: #d9d9d9;
  border-radius: 0.08rem;
  opacity: 1;
  margin-right: 0.1rem;
}

.table_information {
  width: calc(100% - 0.6rem - 0.1rem);
  height: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.topBtn {
  width: 0.8rem;
  height: 0.33rem;
  line-height: 0.33rem;
  background: #C01A26;
  font-size: 0.14rem;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  border-radius: 0.04rem;
  opacity: 1;
  border: none;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

.cancellationBtn {
  width: 100px;
  color: #86909c;
  text-align: center;
  margin-top: 0.08rem;
  cursor: pointer;
}
</style>
